// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_il-0";
export var animationContainer = "_il-1";
export var modalContent = "_il-2";
export var orderName = "_il-3";
export var refundOption = "_il-4";
export var refundOptionsContainer = "_il-5";